import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link } from "@zestia/gatsby-plugin-react-i18next"
import { LuChevronRight } from "react-icons/lu"

const renderOverlayIcon = (overlayIcon, overlayIconAlt) => {
  if (!overlayIcon) return null

  if (typeof overlayIcon === "string") {
    return (
      <img
        src={overlayIcon}
        alt={overlayIconAlt}
        className="image-text-block-linked__image-overlay-icon"
      />
    )
  }

  const OverlayIcon = overlayIcon

  return (
    <OverlayIcon
      className="image-text-block-linked__image-overlay-icon"
      aria-hidden={!overlayIconAlt}
      aria-label={overlayIconAlt || undefined}
      role={overlayIconAlt ? "img" : undefined}
    />
  )
}

const ImageWithTextBlockLinked = ({
  image,
  title,
  text,
  kicker,
  supportingText,
  imageText,
  link,
  imageClassName = "",
  className = "",
  overlayColor,
  overlayIcon,
  overlayIconAlt = "",
  showChevron = false,
}) => {
  const content = (
    <div className={`image-text-block__wrapper ${className}`.trim()}>
      <article className="image-text-block image-text-block--linked">
        {image && (
          <div className="image-text-block__image-container">
            <GatsbyImage
              className={`image-text-block-blog__image ${imageClassName}`}
              image={getImage(image.src)}
              alt={image.alt}
            />
            {(overlayColor || overlayIcon) && (
              <div
                className="image-text-block-linked__image-overlay"
                style={{ background: overlayColor || undefined }}
              >
                {renderOverlayIcon(overlayIcon, overlayIconAlt)}
              </div>
            )}
            {imageText && (
              <h3 className="image-text-block__image-text">{imageText}</h3>
            )}
          </div>
        )}
        <div className="image-text-block__text">
          {kicker && (
            <span className="heading-kicker heading-kicker--no-status">
              {kicker}
            </span>
          )}
          {title && (
            <div className="image-text-block__title-row">
              <h4 className="mb-2">{title}</h4>
              {showChevron && (
                <LuChevronRight className="image-text-block__link-icon" />
              )}
            </div>
          )}
          {text && <p>{text}</p>}
          {supportingText && <p>{supportingText}</p>}
        </div>
      </article>
    </div>
  )

  if (!link) {
    return content
  }

  return link.startsWith("http") ? (
    <a href={link} className="image-text-block__link" target="_blank" rel="noopener noreferrer">
      {content}
    </a>
  ) : (
    <Link to={link} className="image-text-block__link">
      {content}
    </Link>
  )
}

export default ImageWithTextBlockLinked
